export default __webpack_public_path__ + "static/media/GR00006-owl.101271fa.svg";